module.exports = __webpack_public_path__ + "img/good-3.b8c64477.png";